module.exports = __webpack_public_path__ + "static/img/8.5fae8d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/3/sp/8.png
// module id = nzwq
// module chunks = 0